var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              !this.showPlayer || !this.oneTrustCheck.isTargetingCookiesActive,
            expression:
              "!this.showPlayer || !this.oneTrustCheck.isTargetingCookiesActive",
          },
        ],
        staticClass: "show-message youtube__cookie-error-message",
      },
      [
        _c(
          "svg",
          {
            staticStyle: { "max-height": "80px" },
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 52 60",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M10.15,53.91l5.13-2.96-.92,2.84-3.21,1.85c-.91.52-1.9.78-2.89.78s-1.99-.26-2.89-.78c-1.81-1.05-2.89-2.92-2.89-5.01V7.37c0-2.09,1.08-3.97,2.89-5.01,1.81-1.05,3.98-1.05,5.79,0l16.77,9.68-.63,1.94L10.15,4.09c-.59-.34-1.24-.51-1.89-.51s-1.3.17-1.89.51c-1.19.68-1.89,1.91-1.89,3.28v43.25c0,1.37.71,2.59,1.89,3.28,1.19.69,2.6.69,3.79,0ZM48.6,23.99l-13.86-8-.63,1.94,13.49,7.79c1.19.68,1.89,1.91,1.89,3.28s-.71,2.59-1.89,3.28l-22.35,12.9-.92,2.84,24.27-14.01c1.81-1.05,2.89-2.92,2.89-5.01s-1.08-3.97-2.89-5.01ZM35.94.83c-.52-.17-1.09.12-1.26.64l-18.35,56.48c-.17.52.12,1.09.64,1.26.1.03.21.05.31.05.42,0,.81-.27.95-.69L36.59,2.09c.17-.53-.12-1.09-.64-1.26Z",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("p", { domProps: { textContent: _vm._s(_vm.errormessage) } }),
        _vm._v(" "),
        _c("div", { staticClass: "btn btn--black" }, [
          _c("a", {
            staticClass: "youtube__cookie-error-bt ot-sdk-show-settings",
            attrs: { rel: "noopener noreferrer", href: "#0" },
            domProps: { textContent: _vm._s(this.errorbuttonlabel) },
          }),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              this.showPlayer && this.oneTrustCheck.isTargetingCookiesActive,
            expression:
              "this.showPlayer && this.oneTrustCheck.isTargetingCookiesActive",
          },
        ],
        staticClass: "youtube",
        class: { "is-active": _vm.isActive, "is-ready": _vm.isReady },
        on: { click: _vm.play },
      },
      [
        _c(
          "button",
          {
            ref: "button",
            staticClass: "youtube__button",
            attrs: { disabled: !this.isReady, type: "button" },
            on: { click: _vm.play },
          },
          [_c("span", { staticClass: "sr-only" }, [_vm._v(_vm._s(_vm.label))])]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "youtube__frame",
          attrs: { id: "youtube-" + _vm.guid },
        }),
        _vm._v(" "),
        _c("picture", { staticClass: "youtube__poster" }, [
          _c("img", {
            attrs: { src: _vm.videoPoster, alt: "YouTube video poster" },
          }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }